
import { Vue, Options } from 'vue-class-component'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faXmark } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { generatePastMonths } from '@/helpers/date'
import { mapState, useStore } from 'vuex'
import { isExactString } from '@/utils/object'

library.add(faXmark)

@Options({
  computed: {
    ...mapState({
      selectedMonth: (state: any) => state.coinHistory.selectedMonth,
      // monthsList: (state: any) => state.coinHistory.months,
    }),
  },
  components: {
    FontAwesomeIcon,
  },
})
export default class ModalBottomTieredPoints extends Vue {
  store = useStore();
  private active = true;
  private monthsList = generatePastMonths('MMMM BBBB')

  mounted() {
    this.setOpacity()
  }

  setOpacity() {
    const modalElement = document.getElementsByClassName(
      'dummy-background-tiered-points'
    )[0]! as HTMLElement
    setTimeout(() => {
      modalElement.style.opacity = '0.7'
    }, 10)
  }

  closeModal() {
    const dialogElement = document.getElementsByClassName(
      'modal-dialog-tiered-points'
    )[0]! as HTMLElement
    const modalElement = document.getElementsByClassName(
      'dummy-background-tiered-points'
    )[0]! as HTMLElement

    dialogElement.style.bottom = '-100%'
    modalElement.style.opacity = '0'
    this.store.commit('coinHistory/updateModalCalendarActive', false)
  }

  onClickOutside(event: any) {
    const elClassName = event.target.className
    if (isExactString(elClassName)) {
      this.closeModal()
      this.store.commit('coinHistory/updateModalCalendarActive', false)
    }
  }

  onSelected(value: number) {
    const elemenCoinHistory = document.getElementById('coin-history-list')
    const selectedMonthElement = document.getElementById(`month_${value}`)

    if(elemenCoinHistory && selectedMonthElement) {
      elemenCoinHistory.scrollTo({
        top: selectedMonthElement.offsetTop - 50,
        behavior: 'smooth'
      })
    }
    this.store.commit('coinHistory/updateSelectedCalendar', value)   
    this.store.commit('coinHistory/updateModalCalendarActive', false) 
  }
}
